import { render, staticRenderFns } from "./BatchTransferCopyPromptButton.vue?vue&type=template&id=489dbffc"
import script from "./BatchTransferCopyPromptButton.vue?vue&type=script&lang=js"
export * from "./BatchTransferCopyPromptButton.vue?vue&type=script&lang=js"
import style0 from "./BatchTransferCopyPromptButton.vue?vue&type=style&index=0&id=489dbffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports